import {
  constructionAsset,
  constructionSafety,
  logisticsAsset,
  logisticsSafety,
  manufacturingAsset,
} from '@pages/Enterprise/Solution/components/Banner/BannerImages';
import productImg from '../main/product/productImg';
import productPurchase from '../main/product/productPurchase';

export default {
  desc: 'Quản lý hàng tồn kho là cốt lõi của chuỗi cung ứng tại các trung tâm logistics. Do đó, các nhà quản lý logistics mong muốn phát triển doanh nghiệp luôn trăn trở về việc quản lý hàng tồn kho hiệu quả hơn. Tất nhiên, không chỉ riêng quản lý hàng tồn kho, họ còn tìm kiếm những phương pháp thông minh nhất để nâng cao hiệu quả và năng suất của toàn bộ hệ thống logistics.\nVới sự phát triển gần đây của Hệ thống Định vị Thời gian Thực (RTLS - Real-time Location System), các kho logistics đã có thể xây dựng những hệ thống với hình thái khác biệt so với trước đây. Giờ đây, mọi thứ bên trong kho logistics đều có thể được theo dõi. Vị trí của hàng tồn kho, công nhân, xe nâng, v.v., được hiển thị theo thời gian thực trên một bản đồ mô phỏng giống hệt như kho logistics. Bằng công nghệ tinh vi với sai số gần như không có, mọi thứ tại hiện trường đều có thể được nắm bắt chỉ trong nháy mắt. Điều này không chỉ dừng lại ở việc theo dõi vị trí đơn thuần mà còn mang tiềm năng ứng dụng thành nhiều chức năng đa dạng.',
  keywords:
    'Trung tâm logistics quy mô lớn, Trung tam logistics quy mo lon, Smart logistics, Logistics thông minh, Logistics thong minh, Quản lý kho, Quan ly kho, Smart inventory, Quản lý kho thông minh, Quan ly kho thong minh',
  ogSite: 'Lý do kho logistics thông minh (Smart Logistics Warehouse) đang dẫn đầu ngành',
  title: 'Lý do kho logistics thông minh (Smart Logistics Warehouse) đang dẫn đầu ngành',
  ogUrl: 'https://orbro.io/vi/blog/smartLogistics',
  ogImg: '',
  ogType: 'website',
  date: '2023-08-03',
  tag1: '#Trungtamlogisticsquymolon ',
  tag2: '#Smartlogistics',
  tag3: '#Logisticsthongminh',
  tag4: '#Quanlykho #Smartinventory #Quanlykhothongminh',
  text: [
    {
      head: '',
      subHead: '',
      desc: 'Quản lý hàng tồn kho là cốt lõi của chuỗi cung ứng tại các trung tâm logistics. Do đó, các nhà quản lý logistics mong muốn phát triển doanh nghiệp luôn trăn trở về việc quản lý hàng tồn kho hiệu quả hơn. Tất nhiên, không chỉ riêng quản lý hàng tồn kho, họ còn tìm kiếm những phương pháp thông minh nhất để nâng cao hiệu quả và năng suất của toàn bộ hệ thống logistics.\nVới sự phát triển gần đây của Hệ thống Định vị Thời gian Thực (RTLS - Real-time Location System), các kho logistics đã có thể xây dựng những hệ thống với hình thái khác biệt so với trước đây. Giờ đây, mọi thứ bên trong kho logistics đều có thể được theo dõi. Vị trí của hàng tồn kho, công nhân, xe nâng, v.v., được hiển thị theo thời gian thực trên một bản đồ mô phỏng giống hệt như kho logistics. Bằng công nghệ tinh vi với sai số gần như không có, mọi thứ tại hiện trường đều có thể được nắm bắt chỉ trong nháy mắt. Điều này không chỉ dừng lại ở việc theo dõi vị trí đơn thuần mà còn mang tiềm năng ứng dụng thành nhiều chức năng đa dạng.\n\nDưới đây, chúng tôi sẽ giải thích các chức năng đa dạng có thể đạt được thông qua công nghệ này.',
      dot: '',
    },
    {
      head: 'Xác định vị trí hàng tồn kho',
      subHead: '',
      desc: 'Có thể xác định vị trí của hàng tồn kho bên trong kho logistics. Khi chọn một khu vực, có thể xác định vị trí và số lượng hàng tồn kho hiện có trong khu vực đó. Nếu muốn tìm một mặt hàng cụ thể, có thể sử dụng chức năng tìm kiếm để xác định vị trí của nó bên trong kho. Nếu hàng tồn kho đang được di chuyển, có thể theo dõi lộ trình của nó theo thời gian thực.\nCó thể sắp xếp hàng tồn kho dựa trên mức độ phổ biến của mặt hàng và tối ưu hóa vòng quay hàng tồn kho, điều này giúp cắt giảm chi phí và ngăn chặn tình trạng thiếu hụt hoặc dư thừa hàng tồn kho. Và nếu có thông tin vị trí hàng tồn kho chính xác, nhân viên logistics có thể nhanh chóng tìm thấy hàng hóa và di chuyển chúng đến vị trí cần thiết. Qua đó, có thể rút ngắn thời gian làm việc và nâng cao năng suất.',
      dot: '',
    },
    {
      head: 'Tự động hóa quy trình xuất nhập kho',
      subHead: '',
      desc: 'Thời gian xuất nhập kho của hàng tồn kho đi qua các điểm được chỉ định trước sẽ được ghi lại theo thời gian thực. Dữ liệu này chính xác, do đó có thể ngăn chặn lỗi của con người và tiết kiệm nhân lực. Hơn nữa, dữ liệu này được lưu trữ thông qua Cloud, do đó không có rủi ro quản lý phức tạp hoặc mất mát dữ liệu.',
      dot: '',
    },
    {
      head: 'Rút ngắn thời gian thực hiện (Lead Time)',
      subHead: '',
      desc: 'Thông qua việc theo dõi hàng tồn kho theo thời gian thực, có thể đạt được thời gian thực hiện (Lead Time) nhanh hơn. Do biết chính xác vị trí hàng tồn kho, có thể nhanh chóng tìm thấy hàng cần thiết và rút ngắn thời gian cần cho sản xuất hoặc giao hàng.',
      dot: '',
    },
    {
      head: 'Quản lý an toàn',
      subHead: '1. Theo dõi người lao động',
      desc: 'Theo dõi vị trí của người lao động theo thời gian thực để giám sát tình hình an toàn, và giúp ứng phó nhanh chóng trong trường hợp họ tiếp cận khu vực nguy hiểm hoặc xảy ra tình huống khẩn cấp. Qua đó, phòng ngừa trước các rủi ro tiềm ẩn.',
      dot: '',
    },
    {
      head: '',
      subHead: '2. Thiết lập khu vực nguy hiểm',
      desc: 'Có thể thiết lập trước những nơi không được phép tiếp cận hoặc cần chú ý tại hiện trường để gửi cảnh báo cho người lao động đi qua gần đó hoặc thông báo cho người quản lý. Qua đó, có thể phòng ngừa tai nạn.',
      dot: '',
    },
    {
      head: '',
      subHead: '3. Quản lý xe nâng',
      desc: 'Không chỉ con người cần chú ý đến an toàn. Có thể xác định vị trí của thiết bị nặng có nguy cơ gây tai nạn tiềm ẩn theo thời gian thực, phát hiện các trường hợp người lao động đến gần hoặc đi vào đường không đúng để phòng ngừa tai nạn.',
      dot: '',
    },
    {
      head: '',
      subHead: '4. Bảo vệ tài sản (hàng tồn kho)',
      desc: 'Giúp ngăn chặn tổn thất và trộm cắp hàng tồn kho. Khi hàng tồn kho được phân bổ đến từng vị trí và được theo dõi theo thời gian thực, có thể nhanh chóng phát hiện việc mất mát hoặc trộm cắp hàng tồn kho. Qua đó, giảm thiểu tổn thất hàng tồn kho và thực hiện các biện pháp thu hồi.',
      dot: '',
    },
  ],

  link: {
    page: 'rtls',
    numb: '1',
    product: [
      {
        text: productPurchase.purchase.ble.bleStarterKit.title,
        title: productPurchase.purchase.ble.bleStarterKit.title,
        serial: productPurchase.purchase.ble.bleStarterKit.serial,
        desc: 'Sản phẩm này giúp gắn thiết bị UWB lên nhân viên hoặc thiết bị, hỗ trợ theo dõi vị trí theo thời gian thực.',
        img: productImg.product.bleStarterKit.key1,
      },
      {},
    ],
    solution: [
      {
        img: logisticsAsset.thumb,
        data: 'logisticsAsset',
        link: '/vi/enterprise/logistics/asset',
      },
      {
        img: logisticsSafety.thumb,
        data: 'logisticsSafety',
        link: '/vi/enterprise/logistics/safety',
      },
      {
        img: manufacturingAsset.thumb,
        data: 'manufacturingAsset',
        link: '/vi/enterprise/manufacturing/asset',
      },
    ],
  },
};
